import React, { createContext, useState, useContext, useEffect } from 'react'

// Create the context
const ThemeContext = createContext()

// Theme provider component
export const ThemeProvider = ({ children }) => {
  // Check localStorage for saved preference, default to 'okb'
  const [theme, setTheme] = useState(() => {
    const savedTheme = localStorage.getItem('theme')
    return savedTheme || 'okb'
  })

  // Save theme preference to localStorage when it changes
  useEffect(() => {
    localStorage.setItem('theme', theme)
  }, [theme])

  // Toggle between themes
  const toggleTheme = () => {
    setTheme(prevTheme => prevTheme === 'okb' ? 'havas' : 'okb')
  }

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  )
}

// Custom hook for using the theme
export const useTheme = () => {
  const context = useContext(ThemeContext)
  if (context === undefined) {
    throw new Error('useTheme must be used within a ThemeProvider')
  }
  return context
}
